import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const NewSearchBar = ({
  filter,
  setFilter,
  setOpen,
  t,
  searchIcon,
  addIcon,
  filterIcon,
  PostSearchBar,
  handleSearch,
  admin = false,
  addLabel,
  searchPlaceholder,
  searchLabel,
  onFilterClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid item xs={12} md={10} lg={8}>
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "20px",
            border: "1px solid #e0e0e0",
            p: { xs: 1.5, sm: 1.5 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 1.5,
            width: "100%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            mr: 6,
            mt: 2,
            mb: 6,
          }}
        >
          {/* Search Input */}
          <PostSearchBar
            className="search-bar-container"

            variant="outlined"
            size="small"
            type="text"
            placeholder={searchPlaceholder || (admin ? t("postPage.filterRecruiter") : t("postPage.searchPlaceholder"))}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 auto" },
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={searchIcon} height={15} width={15} alt="search" />
                </InputAdornment>
              ),
            }}
          />

          {/* Button Group */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1.5,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {/* Search Button */}
            <Button
              variant="contained"
              onClick={handleSearch}
              sx={{
                textTransform: "none",
                fontFamily: "Poppins",
                height: { xs: 45, sm: 50 },
                borderRadius: "11px",
                p: "14px 26px",
                width: { xs: "100%", sm: 106 },
                whiteSpace: "nowrap",
              }}
            >
              {t('postPage.search')}
            </Button>

            {/* Add Post Button */}
            <Button
              className="create-offer-btn"
              onClick={() => setOpen(true)}
              variant="contained"
              type="submit"
              sx={{
                height: { xs: 45, sm: 50 },
                borderRadius: "10px",
                backgroundColor: "white",
                border: "1px solid #0017E7",
                boxShadow: "none",
                width: { xs: "100%", sm: 'auto' },
                px: { xs: 2, sm: 3 },
                ":hover": {
                  backgroundColor: "#f0f4ff",
                  boxShadow: "0 2px 4px rgba(0, 23, 231, 0.2)",
                },
                transition: "all 0.3s ease",
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                whiteSpace: 'nowrap'
              }}
            >
              <img src={addIcon} alt="Add" style={{ maxHeight: 20 }} />
              <Typography
                sx={{
                  color: "#0017E7", // colors.primary
                  textTransform: "none",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: { xs: 11, sm: 12 },
                  whiteSpace: 'nowrap'
                }}
              >
                {addLabel || (admin ? t("postPage.addRecruiterButton") : t("postPage.addPostButton"))}
              </Typography>
            </Button>

            {/* Filter Button */}
            {!admin &&
              <Button
                className='filter-offer-btn'
                variant="outlined"
                onClick={onFilterClick}
                sx={{
                  border: "1px solid #0017E7",
                  borderRadius: "11px",
                  backgroundColor: "#fff",
                  boxShadow: "none",
                  height: { xs: 45, sm: 50 },
                  width: { xs: "100%", sm: 50 },
                  minWidth: { xs: "100%", sm: 50 },
                  p: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    backgroundColor: "#f0f4ff",
                    boxShadow: "0 2px 4px rgba(0, 23, 231, 0.2)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <img
                  src={filterIcon}
                  alt="Filter"
                  style={{
                    width: isMobile ? 18 : 20,
                    height: isMobile ? 18 : 20,
                  }}
                />
              </Button>
            }

          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default NewSearchBar;
